const peakIcon = 'M15,3H17L22,5L17,7V10.17L22,21H2L8,13L11.5,17.7L15,10.17V3Z';

export default peakIcon;
